import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Measure } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Equivalence, MeasureLabel, Product, ProductType } from '../state/types'

export const useProductBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildProduct = (data: Data2) => {
        const {
            id = newId(),
            code,
            supplierCode,
            name,
            categoryId,
            supplierId,
            imageUrl,
            description,
            type,
            units,
            unitTypeId,
            secondaryUnits,
            secondaryUnitTypeId,
            measures,
            unitMeasures,
            measureLabel,
            loted,
            allowNegativeStock,
            equivalences,
            archived
        } = data

        const product: Product = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            supplierCode: supplierCode! as string,
            name: name! as string,
            categoryId: categoryId! as string,
            supplierId: supplierId! as string,
            imageUrl: imageUrl as O<string>,
            description: description as O<string>,
            type: type! as ProductType,
            units: units as O<number>,
            unitTypeId: unitTypeId! as string,
            secondaryUnits: secondaryUnits as O<number>,
            secondaryUnitTypeId: secondaryUnitTypeId as O<string>,
            measures: (measures || []) as Measure[],
            unitMeasures: unitMeasures as O<Measure[]>,
            measureLabel: measureLabel as O<MeasureLabel>,
            loted: !!loted,
            allowNegativeStock: !loted && !!allowNegativeStock,
            equivalences: equivalences as O<Equivalence[]>,
            archived: !!archived
        }

        return product
    }

    return {
        buildProduct
    }
}
